<template>
  <div class="change-phone">
    <div class="hd m-b-15" v-if="!isNew">
      <div class="item" :class="!isNextStep && 'active'">1</div>
      <div class="line"></div>
      <div class="item" :class="isNextStep && 'active'">2</div>
    </div>

    <el-form size="small" ref="form" :model="form" label-width="80px" status-icon :rules="changeRules">
      <template v-if="!isNextStep">
        <el-form-item>
          <el-input
            placeholder="请输入旧的手机号"
            name="phone"
            type="text"
            v-model.trim="form.oldPhone"
            disabled
          >
            <template slot="prepend">旧手机号</template>
          </el-input>
        </el-form-item>
        <el-form-item prop="oldCaptcha" class="input-flex-append">
          <el-input
            ref="oldCaptcha"
            v-model.trim="form.oldCaptcha"
            placeholder="请输入图形验证码"
            style="width: 177px"
            name="oldCaptcha"
            type="text"
            tabindex="1"
            autocomplete="on"
          >
            <template slot="prepend">图&#8194;形&#8194;码</template>
          </el-input>
          <img @click="resetOldCap" :src="oldCaptchaSrc" class="captcha" width="120px" />
        </el-form-item>
        <el-form-item class="input-flex-append">
          <el-input
            placeholder="请输入短信验证码"
            name="oldSMSCode"
            type="text"
            tabindex="1"
            autocomplete="on"
            v-model.trim="form.oldSMSCode"
            style="width:65%"
          >
            <template slot="prepend">验&#8194;证&#8194;码</template>
          </el-input>
          <el-button
            :disabled="!!sec"
            class="send-sms"
            @click.native="sendOldCode"
          >{{sec ? `${sec}s` : '发送验证码'}}</el-button>
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item>
          <el-input placeholder="请输入手机号" name="phone" type="text" v-model.trim="form.newPhone">
            <template slot="prepend">{{isNew ? '手&#8194;机&#8194;号': '新手机号'}}</template>
          </el-input>
        </el-form-item>
        <el-form-item prop="newCaptcha" class="input-flex-append">
          <el-input
            ref="newCaptcha"
            v-model.trim="form.newCaptcha"
            placeholder="请输入图形验证码"
            name="newCaptcha"
            type="text"
            style="width: 177px"
            tabindex="1"
            autocomplete="on"
          >
            <template slot="prepend">图&#8194;形&#8194;码</template>
          </el-input>
          <img @click="resetNewCap" :src="newCaptchaSrc" class="captcha" width="120px" />
        </el-form-item>
        <el-form-item class="input-flex-append">
          <el-input
            placeholder="请输入短信验证码"
            name="newSMSCode"
            type="text"
            tabindex="1"
            autocomplete="on"
            v-model.trim="form.newSMSCode"
            style="width:65%"
          >
            <template slot="prepend">验&#8194;证&#8194;码</template>
          </el-input>
          <el-button
            :disabled="!!sec2"
            class="send-sms"
            @click.native="sendNewCode"
          >{{sec2 ? `${sec2}s` : '发送验证码'}}</el-button>
        </el-form-item>
      </template>
      <el-form-item class="m-t-15">
        <el-button
          :loading="loading"
          @click="changePhone"
          v-if="isNextStep"
          class="width-full"
          type="primary"
        >保存</el-button>
        <el-button :loading="loading" @click="nextStep" v-else class="width-full" type="primary">下一步</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { Form, FormItem, Input } from 'element-ui';
import env from '@/api/env';
import { sys } from '@/api';
import pattern from '@/utils/pattern';

export default {
  components: {
    ElForm: Form,
    ElFormItem: FormItem,
    ElInput: Input
  },
  data() {
    return {
      baseUrl: env.baseUrl,
      captchaTime: new Date().getTime(),
      isNextStep: false,
      MAX_SEC: 60,
      sec: 0,
      MAX_SEC2: 60,
      sec2: 0,
      loading: false,
      form: {
        oldPhone: this.$store.state.user.info.telephone,
        newPhone: '',
        oldSMSCode: '',
        newSMSCode: '',
        oldCaptcha: '',
        newCaptcha: ''
      },
      changeRules: {
        OldSMScode: [
          {
            required: true,
            message: '请填写正确的手机验证码',
            trigger: 'blur',
            pattern: pattern.code
          }
        ],
        oldCaptcha: [
          {
            required: true,
            message: '请填写正确的图形码',
            trigger: 'blur',
            pattern: pattern.captcha
          }
        ]
      },
      oldCaptchaSrc: '',
      newCaptchaSrc: ''
    };
  },
  computed: {
    user() {
      return this.$store.state.user.info;
    },
    isNew() {
      return !this.form.oldPhone;
    }
  },
  mounted() {
    // 加载旧手机号图形验证码
    sys.changePhone({ methlod: 'get' }).then(res => {
      if (!res) return;
      this.getData(res);
    });
    if (!this.form.oldPhone) {
      this.isNextStep = true;
    }
  },
  methods: {
    async changePhone() {
      if (!pattern.mobile.test(this.form.newPhone)) {
        this.$message.warning('请输入正确的手机号！');
        return;
      }
      if (!pattern.captcha.test(this.form.newCaptcha)) {
        this.$message.warning('请输入正确的图形码！');
        return;
      }
      if (!pattern.noEmpty.test(this.form.newSMSCode)) {
        this.$message.warning('请输入手机验证码！');
        return;
      }

      const res = await sys.changeNewPhone({
        params: {
          phone_num: this.form.newPhone,
          sms_ver_code: this.form.newSMSCode
        },
        methold: 'put'
      });

      if (res) {
        this.$message({
          message: res.msg || '绑定手机号成功',
          type: 'success'
        });
        this.$emit('closeWindow');
      }
    },

    getData(data) {
      if (!data) {
        return;
      }
      const blob = new Blob([data]);
      if (this.isNextStep) {
        this.newCaptchaSrc = window.URL.createObjectURL(blob);
      } else {
        this.oldCaptchaSrc = window.URL.createObjectURL(blob);
      }
    },

    async sendOldCode() {
      if (!pattern.mobile.test(this.form.oldPhone)) {
        this.$message.warning('请输入正确的手机号！');
        return;
      }
      if (!pattern.captcha.test(this.form.oldCaptcha)) {
        this.$message.warning('请输入正确的图形码！');
        return;
      }
      const res = await sys.changePhone({
        params: {
          image_ver_code: this.form.oldCaptcha,
          phone_num: this.form.oldPhone
        },
        methold: 'post'
      });
      if (res) {
        if (this.sec === 0) {
          this.sec = this.MAX_SEC;
          this.setTime();
        }
      } else {
        this.resetOldCap();
      }
    },
    async sendNewCode() {
      if (!pattern.mobile.test(this.form.newPhone)) {
        this.$message.warning('请输入正确的手机号！');
        return;
      }
      if (!pattern.captcha.test(this.form.newCaptcha)) {
        this.$message.warning('请输入正确的图形码！');
        return;
      }
      const res = await sys.changeNewPhone({
        params: {
          image_ver_code: this.form.newCaptcha,
          phone_num: this.form.newPhone
        },
        methold: 'post'
      });
      if (res) {
        if (this.sec2 === 0) {
          this.sec2 = this.MAX_SEC2;
          this.setTime2();
        }
      } else {
        this.resetNewCap();
      }
    },

    setTime() {
      this.sec = this.sec - 1;
      if (this.sec > 0) {
        this.timer = setTimeout(() => {
          this.setTime();
        }, 1000);
      }
    },
    setTime2() {
      this.sec2 = this.sec2 - 1;
      if (this.sec2 > 0) {
        this.timer = setTimeout(() => {
          this.setTime2();
        }, 1000);
      }
    },
    resetOldCap() {
      sys.changePhone({ methlod: 'get' }).then(res => {
        if (!res) return;
        this.getData(res);
      });
    },
    resetNewCap() {
      sys.changeNewPhone({ methlod: 'get' }).then(res => {
        if (!res) return;
        this.getData(res);
      });
    },
    async nextStep() {
      if (!pattern.mobile.test(this.form.oldPhone)) {
        this.$message.warning('请输入正确的手机号！');
        return;
      }
      if (!pattern.captcha.test(this.form.oldCaptcha)) {
        this.$message.warning('请输入正确的图形码！');
        return;
      }
      if (!pattern.noEmpty.test(this.form.oldSMSCode)) {
        this.$message.warning('请输入手机验证码！');
        return;
      }
      const res = await sys.changePhone({
        params: {
          sms_ver_code: this.form.oldSMSCode
        },
        methold: 'put'
      });
      if (res) this.isNextStep = true;
      // 调用新手机号的图片验证码
      this.resetNewCap();
    }
  }
};
</script>
<style lang="less">
.change-phone {
  margin-right: 80px;
  .send-sms {
    margin-left: 18px;
    width: 112px;
    text-align: center;
  }
  .input-flex-append .el-form-item__content {
    display: flex;
    .el-input {
      flex: 1;
    }
    img {
      margin-left: 10px;
    }
    .send-sms {
      margin-left: 18px;
      width: 112px;
      text-align: center;
    }
  }
  h2 {
    text-align: center;
  }
  .hd {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 80px;
    .line {
      width: 100px;
      height: 1px;
      border-top: 1px solid #ccc;
    }
    .item {
      margin: 10px 20px;
      border: 1px solid @main-blue;
      width: 50px;
      height: 50px;
      border-radius: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      &.active {
        color: #fff;
        background: @main-blue;
      }
    }
  }
}
</style>
